import { render, staticRenderFns } from "./provider-issuecertificates-step2.vue?vue&type=template&id=a24090fc&scoped=true"
import script from "./provider-issuecertificates-step2.vue?vue&type=script&lang=js"
export * from "./provider-issuecertificates-step2.vue?vue&type=script&lang=js"
import style0 from "./provider-issuecertificates-step2.vue?vue&type=style&index=0&id=a24090fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a24090fc",
  null
  
)

export default component.exports